import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import { withRouter } from 'react-router';

const checkIfKiosk = ({ location: { pathname } }) => /kiosk/.test(pathname);

const preventRenderForKioskMode = compose(
  withRouter,
  branch(
    checkIfKiosk,
    renderNothing,
  )
);

export default preventRenderForKioskMode;



// WEBPACK FOOTER //
// ./src/app/hoc/preventRenderForKioskMode.js